<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-school layout map-marker"
            :class="{ active: active === fmLatlng }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @click="onClick"
            @touchstart.prevent="onClick"
            v-outsideclick="outsideClick"
        >
            <i class="iconfont" :class="icon">
                <span class="count" v-if="data.count > 1">{{ data.count }}</span>
            </i>
            <div
                v-if="!isMobileSize"
                ref="pop"
                class="marker-pop map-school-pop"
                :class="{ bottom: popBottom }"
                :style="popStyle"
            >
                <span ref="popinter" class="pointer" :style="pointerStyle"></span>
                <SchoolList @mouseleave="onMouseLeave" :list="data?.items || []" />
            </div>
            <Teleport v-else to="body">
                <div
                    v-if="showMarkerPop"
                    class="marker-pop map-school-pop"
                    :style="mobilePopStyle"
                >
                    <SchoolList @mouseleave="onMouseLeave" :list="data?.items || []" />
                </div>
            </Teleport>
        </div>
    </Teleport>
</template>
<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import useMarker from '../hook/useMarker';
import SchoolList from './school-list.vue';
// 定义props
const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    events: {
        type: Object,
        default: () => ({})
    },
    active: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: 'icon-school2'
    }
});

// 定义emit
const emit = defineEmits(['update:active']);

// 计算属性
const { proxy } = getCurrentInstance();
const isMobileSize = computed(() => proxy.platform.isMobile);

// 引用DOM元素
const markerRef = ref(null);
const pop = ref(null);
const popinter = ref(null);
const parentDom = ref(null);
const mobilePopStyle = ref({ display: 'block' });

// 使用useMarker
const {
    showMarkerPop,
    popStyle,
    popBottom,
    fmLatlng,
    onMouseEnter,
    onMouseLeave,
    onClick,
    outsideClick
} = useMarker({
    props,
    emit,
    parentDom,
    pop,
    popinter,
    markerRef,
    markerClassName: 'map-school-wrapper',
    showFn: () => {
        mobilePopStyle.value = { display: 'block' };
    },
    hiddenFn: () => {
        mobilePopStyle.value = { display: 'none' };
    }
});

</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
.map-school-pop {
    background-color: var(--g-bg-color);
    width: 280px;
    padding: 0;
    border: 1px solid var(--color-border);
    box-shadow: 0px 1.6px 8px 0px rgba(0, 10, 30, 0.1);
    
    .pointer {
        border-top-color: var(--g-bg-color);
    }
    &.bottom {
        .pointer {
            border-bottom-color: var(--g-bg-color);
        }
    }
    @include media-800 {
        position: fixed;
        left: 15px;
        bottom: 90px;
        border-radius: 4px;
        width: calc(100% - 30px);
    }
}
</style>